import { OrganizationRole } from '@/enums/roles';
import EmployeeProfile from '@/views/EmployeeProfile.vue';
import Employees from '@/views/admin/Employees.vue';
import TeamProfile from '@/views/teams/TeamProfile.vue';
import Teams from '@/views/teams/Teams.vue';
import type { RouteRecordRaw } from 'vue-router';

const routes: readonly RouteRecordRaw[] = [
    {
        path: '/medewerker/:id',
        name: 'employee',
        component: EmployeeProfile,
        meta: {
            pageTitle: 'Medewerkersprofiel',
            roles: [OrganizationRole.Employee]
        }
    },
    {
        path: '/team/:id',
        name: 'team',
        component: TeamProfile,
        meta: {
            pageTitle: 'Team',
            roles: [OrganizationRole.Employee]
        }
    },
    {
        path: '/medewerker/:id/teams',
        name: 'my-teams',
        component: Teams,
        meta: {
            pageTitle: 'Mijn teams',
            roles: [OrganizationRole.Employee]
        }
    },
    {
        path: '/medewerkers/:organizationId?',
        name: 'employees',
        component: Employees,
        meta: {
            pageTitle: 'Medewerkers',
            roles: [OrganizationRole.Admin]
        }
    }
];

export default routes;
